/**
 * AppThemeProvider — wraps MUI ThemeProvider with light/dark mode support.
 *
 * Reads the user's OS preference via prefers-color-scheme on initial load.
 * C18 will hook this up to a user settings preference persisted in the API.
 */
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useMemo } from "react";
import type { ReactNode } from "react";
import { createAppTheme } from "@/theme";

interface AppThemeProviderProps {
  children: ReactNode;
}

export function AppThemeProvider({ children }: AppThemeProviderProps) {
  const prefersDark = useMediaQuery("(prefers-color-scheme: dark)");
  const theme = useMemo(() => createAppTheme(prefersDark ? "dark" : "light"), [prefersDark]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
